import React from "react";
import classNames from "classnames/bind";

import { Screen } from "../../components/Screen";
import { DiagramChart } from "components/DiagramChart";
import { DeficitItem } from "components/DeficitItem";

import { useStateManager } from "utils/useStateManager";
import { DietanamnezChartItem } from "types/DietanamnezItem";

import styles from "./Deficit.module.css";

const cx = classNames.bind(styles);

const getPercent = (item: DietanamnezChartItem) => {
	const getOnePercent = (normMin: any, normMax: any) => {
		if (!normMax && !normMin) {
			return 1;
		}
		if (normMax < Infinity) {
			return (normMax / 65);
		}
		return (normMin / 35);
	};

	if (!item.normMin || !item.normMax) {
		return (getOnePercent(item.normMin, item.normMax) || 0) * 50;
	}

	if (item.data && (item.data >= item.normMin && item.data <= item.normMax)) {
		return null;
	}

	if (item.data && item.data < item.normMin) {
		return Math.floor((item.data - item.normMin) * (100 / item.normMin));
	}

	if (item.data && item.data > item.normMax) {
		return Math.floor(item.data * (100 / item.normMax));
	}

	return -100;
};

type Props = {
	onSubmit: (exists?: boolean) => void;
};

export const Deficit: React.FC<Props> = ({ onSubmit }) => {
	const { dietanamnezChartItems } = useStateManager();

	const handleSubmit = async (event: React.FormEvent) => {
		event.preventDefault();
		try {
			onSubmit();
		} catch (error) {
			console.log(error);
		}
	};

	const tabs = [
		{
			title: "Список",
			content: dietanamnezChartItems.map((dietanamnezChartItem: DietanamnezChartItem) => {
				const groupItemsAmount = dietanamnezChartItem.subitems.filter((item) => {
					const percent = getPercent(item);

					return percent !== null && percent < 0;
				}).length;

				return (
					<>
						{!!groupItemsAmount &&
							<div className={cx("items")}>
								<h3 className={cx("items_title")}>{dietanamnezChartItem.label}</h3>
								{dietanamnezChartItem.subitems.map((item) => (
									<DeficitItem
										item={item}
										percent={getPercent(item)}
									/>
								))}
							</div>
						}
					</>
				)
			}),
		},
		{
			title: "Диаграмма",
			content:
				<>
					<div className={cx("diagram_header")}>
						<div></div>
						<div className={cx("diagram_header-items")}>
							<p className={cx("diagram_header-item")}>
								-100%
							</p>
							<p className={cx("diagram_header-item")}>
								Норма
							</p>
							<p className={cx("diagram_header-item")}>
								100%
							</p>
						</div>
					</div>
					{dietanamnezChartItems.map((dietanamnezChartItem: DietanamnezChartItem) => (
						<>
							{!!dietanamnezChartItem.subitems.length &&
								<section key={dietanamnezChartItem.key} className={cx("group")}>
									{dietanamnezChartItem.subitems.map((item) => (
										<div className={cx("diagram_item")}>
											<p className={cx("text")}>
												<span>
													{item.label}, {item.size}
												</span>
											</p>
											<div className={cx("chart")}>
												<DiagramChart
													min={item.normMin}
													max={item.normMax}
													value={item.data}
												/>
											</div>
										</div>
									))}
								</section>
							}
						</>
					))}
				</>
		}
	]
	const [active, setActive] = React.useState<number>(0);
	// @ts-ignore
	const openTab = e => setActive(+e.target.dataset.index);

	return (
		<Screen
			title={<>Выявлен <b>риск дефицита</b> потребления</>}
			buttonTitle="Продолжить"
			onSubmit={handleSubmit}
		>
			<div className={cx("view")}>
				{tabs.map((tab, index) => {
					const isActive = index === active ? "active" : "";

					return (
						<div
							className={cx("view_btn", isActive)}
							onClick={openTab}
							data-index={index}
						>
							{tab.title}
						</div>
					)
				})}
			</div>
			{tabs[active].content}
		</Screen >
	);
};
